export default __webpack_public_path__ + "static/media/st.c321f51b.svg";